import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
export const DateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const DateTimeUnderscoreFormat = 'YYYY_MM_DD_HH_mm_ss';
export const DateTimeMinutesFormat = 'YYYY-MM-DD HH:mm';
export const TimeMinutesFormat = 'HH:mm';
export const TimeMinutesSecondsFormat = 'HH:mm:ss';
export const DateFormat = 'YYYY-MM-DD';
export const MonthFormat = 'YYYY-MM';
export const DateShortFormat = 'YY-MM-DD';
export const DateTimeShortFormat = 'YY-MM-DD HH:mm';
export const DateTimeDisplayFormat = 'MM月DD日 HH:mm';
export const DateTimeFullDisplayFormat = 'YYYY年MM月DD日 HH:mm';

/**默认服务时长 */
export const DefaultServiceDuration = 60;

export const toDateTimeFormat = (v: string | number, format: string = DateTimeFormat) => {
  var day = dayjs(v);
  if (!day.isValid()) return '-';

  return day.format(format);
};

export const formatPeriod = (iso: string) => {
  const d = dayjs.duration(iso);
  const parts: [number, string][] = [
    [d.years(), '年'],
    [d.months(), '个月'],
    [d.days(), '天'],
  ];
  return parts
    .filter(([v]) => v > 0)
    .map(([v, u]) => v + u)
    .join('');
};

export enum API_ERROR_CODE {
  GOODS_NOT_FOUND = 100001,

  PRICE_EMPTY = 10001,
  STOCK_INVALID = 10002,
}

export interface GMTInfo {
  /**创建时间 */
  addTime: string;

  /**修改时间 */
  updateTime: string;
}

export interface EditorInfo {
  /**创建人 */
  creator: string;

  /**修改人 */
  modifier: string;
}

export interface PageParam {
  current?: number;
  pageSize?: number;
}
export interface Page {
  total: number;
  pages?: number;
  pageSize?: number;
  current: number;
}

export interface PagedDataList<DataType> {
  list: DataType[];
  page: Page;
}

export enum Toggle {
  OFF = 0,
  ON = 1,
}
